<template>
  <v-tabs vertical class="elevation-2 mt-2">
    <v-tab v-for="(item, index) in items" :key="index" class="text-left">
      <v-icon left>
        mdi-hvac
      </v-icon>
      {{ item.name }}
    </v-tab>
    <v-tab-item v-for="(item, index) in items" :key="index">
      <HVAC_MAP :plant="item" />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import HVAC_MAP from '@/components/hvac/hvac_map.vue'
export default {
  components: {
    HVAC_MAP,
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  computed: {
    isSuperAdmin: {
      get: function () {
        return this.$store.state.User.isSupperAdmin
      }
    },
    building: {
      get: function () {
        return this.$store.state.User.building
      },
      set: function (newValue) {
        this.$store.dispatch('User/SET_BUILDING', newValue)
      },
    },
    assets() {
      return this.$store.state.Asset.assetAll
    },
    role: {
      get: function () {
        return this.$store.state.User.role
      }
    },
  },
  mounted() {
    this.getHVACPlant()
  },
  methods: {
    getHVACPlant() {
      this.loading = true
      this.$store.dispatch('HVAC/GET_HVAC_PLANT', { BuildingId: this.building.BuildingId }).then((data) => {
        data.forEach(distribution => {
          distribution.asset = this.assets.filter((asset) => {
            return distribution.assetId.filter((assetId) => {
              return assetId === asset.assetId
            }).length > 0
          });
          this.items = data
          this.loading = false
        })
      }).catch((error) => {
        console.log(error)
        this.loading = false
      })
    },
  }
}

</script>